// 🔧 findBestSpotAssignment.js — ZAAWANSOWANA WERSJA z priorytetem najczęściej dostępnych miejsc

import axios from "../api/axiosInstance";

/**
 * Zwraca przypisanie miejsc parkingowych do dat,
 * starając się maksymalizować powtarzalność jednego miejsca
 * i dołącza pełne dane o miejscu (id, spotNumber).
 */
export async function findBestSpotAssignment(dates, baseUrl) {
  const dateStrings = dates.map(d => d.toISOString().split("T")[0]);

  // 1. Pobierz listę wszystkich miejsc
  const spotRes = await axios.get(`${baseUrl}/api/admin/parking-spots`);
  const allSpots = spotRes.data;
  const spotIds = allSpots.map(s => s.id);
  if (!spotIds.length) return {};

  // 2. Pobierz dostępność miejsc
  const startDate = dateStrings[0];
  const endDate = dateStrings[dateStrings.length - 1];
  const availabilityRes = await axios.get(`${baseUrl}/api/reservations/availability`, {
    params: {
      spotIds,
      startDate,
      endDate
    }
  });

  const availabilityMap = availabilityRes.data; // { spotId: [ { date, isFree } ] }

  // 3. Budujemy mapę: spotId → daty dostępne z wybranych
  const spotAvailableDates = {};
  for (const [spotId, records] of Object.entries(availabilityMap)) {
    const availableDates = records
      .filter(r => r.isFree && dateStrings.includes(r.date))
      .map(r => r.date);
    if (availableDates.length) {
      spotAvailableDates[spotId] = availableDates;
    }
  }

  // 4. Posortuj miejsca wg liczby pokrywanych dat (malejąco)
  const sortedSpotIds = Object.entries(spotAvailableDates)
    .sort((a, b) => b[1].length - a[1].length)
    .map(([spotId]) => spotId);

  // 5. Przypisz jak najwięcej dat do jednego miejsca, resztę do kolejnych
  const unassignedDates = new Set(dateStrings);
  const assigned = {}; // spotId -> { spot, dates: [] }

  for (const spotId of sortedSpotIds) {
    const spot = allSpots.find(s => s.id === parseInt(spotId));
    for (const date of spotAvailableDates[spotId]) {
      if (unassignedDates.has(date)) {
        if (!assigned[spotId]) assigned[spotId] = { spot, dates: [] };
        assigned[spotId].dates.push(date);
        unassignedDates.delete(date);
      }
    }
    if (unassignedDates.size === 0) break;
  }

  return assigned; // { spotId: { spot: {...}, dates: [...] } }
}